import { localStorage } from "dash-ui";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useApiFirstAccess = () => {
  const navigate = useNavigate();

  const apiReferralCode = localStorage.getApiReferralCode();
  const isApiFirstAccess = localStorage.getApiFirstAccess();

  useEffect(() => {
    if (apiReferralCode && isApiFirstAccess) {
      navigate(`/auth/sign-up?api-referral=${apiReferralCode}`);
    }
  }, [apiReferralCode, isApiFirstAccess]);
};
